module.exports = __webpack_public_path__ + "static/media/galerija_2021 (18).9ed5aceb.jpg";